module.exports = __webpack_public_path__ + "img/no-image.37cbab97.png";